import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../http.common';
import Swal from 'sweetalert2';
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import ROUTES_NAVIGATION from '../../../../routes/routes';
import { useNavigate } from 'react-router-dom';
import { buttonStyle, isFormValid } from '../../../../helpers/common';

const ReplacementAndRepairDetails = ({
  drawerData,
  toggleDrawer,
  fetchJobCardListRefresh,
}) => {
  const [batteryData, setBatteryData] = useState([]);
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  console.log(drawerData, 'drawerDataInDetailsComponent');
  const token = localStorage.getItem('authToken');
  const userType = localStorage.getItem('UserType');
  const dealerId = localStorage.getItem('dealerId');

  const [isInvoiceUploaded, setIsInvoiceUploaded] = useState(false);

  const [showTableSection, setTableSection] = useState(false);
  const [serialReplacedNumber, setSerialReplacedNumber] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (drawerData) {
      fetchJobCardList();
    }
  }, [drawerData]);

  const fetchJobCardList = async () => {
    const payload = {
      item_id: drawerData?.item_id,
      type_of_service: drawerData?.type_of_service,
    };

    try {
      const response = await axiosInstance.patch(
        `/jobcard/replacement-return-details/${drawerData?.job_card_id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // const formattedData = response?.data?.data?.map((item) => ({
      //   battery_no: item.serial_no,
      //   replaced_battery: "--",
      // }));

      const formattedData = response?.data?.data?.JobCardSubListDetails?.map(
        (item) => ({
          battery_no: item.serial_no?.replace(/"/g, '') || '--', // remove extra quotes from API
          replaced_battery: item.replace_serial_no || '--',
          entered_battery_no: '', // keep editable field intact
        }),
      );

      setBatteryData(formattedData || []);
      console.log(
        response?.data?.data?.JobCardSubListDetails?.[0]?.replace_serial_no,
        'replace_serial_no',
      );
      const serialReplacedNumber =
        response?.data?.data?.JobCardSubListDetails?.[0]?.replace_serial_no;
      setSerialReplacedNumber(serialReplacedNumber);
      console.log(serialReplacedNumber, 'serialReplacedNumber');
      //   if (response?.status == 200) {
      //     toggleDrawer();
      //   }
    } catch (error) {
      console.error('Error fetching business partners:', error);
    } finally {
    }
  };

  // const downloadDeliveryNote = async () => {
  //   try {
  //     const response = await axiosInstance.patch(
  //       `/deliveryNotesPdf/${drawerData?.job_card_id}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       },
  //     );

  //     if (response?.status === 200) {
  //       // toggleDrawer();

  //       Swal.fire({
  //         title: "Success",
  //         text: "Downloaded Successfully!",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //       // fetchJobCardListRefresh();
  //     }

  //     console.log(response, "submit battery status response");
  //   } catch (error) {
  //     console.error("Error submitting battery status:", error);
  //   }
  // };

  const downloadDeliveryNote = async () => {
    try {
      const response = await axiosInstance.patch(
        `/deliveryNotesPdf/${drawerData?.job_card_id}`,
        {
          dealer_id: drawerData?.dealer_id,
          type_of_service: drawerData?.type_of_service,
        }, // body (empty)
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob', // 🔥 REQUIRED
        },
      );

      // Create blob
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      });

      // Extract filename from header (if present)
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'deliveryNote.pdf';

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      }

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        title: 'Success',
        text: 'Downloaded Successfully!',
        icon: 'success',
        confirmButtonText: 'OK',
      });
    } catch (error) {
      console.error('Error downloading PDF:', error);

      Swal.fire({
        title: 'Error',
        text: 'Failed to download PDF',
        icon: 'error',
      });
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await axiosInstance.get(
        `/jobcard/dispatchApprovalDealer/${drawerData?.job_card_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.status === 200) {
        toggleDrawer();

        Swal.fire({
          title: 'Success',
          text: 'Submitted Successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        fetchJobCardListRefresh();
      }

      console.log(response, 'submit battery status response');
    } catch (error) {
      console.error('Error submitting battery status:', error);
    }
  };

  const handleAcceptBattery = async () => {
    try {
      // const payload = {
      //   battery_numbers: batteryData
      //     .map((item) => item.entered_battery_no?.trim())
      //     .filter((val) => val),
      //   postock_id: drawerData?.postock_id,
      //   vinNo: drawerData?.vin_no,
      // };
      // postock_id
      const response = await axiosInstance.patch(
        `/jobcard/transitApprovalDealer/${drawerData?.job_card_id}`,
        {
          replace_serial_no: serialReplacedNumber,
          // item_id:drawerData?.item_id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.status === 200) {
        toggleDrawer();

        Swal.fire({
          title: 'Success',
          text: 'Accepted successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        fetchJobCardListRefresh();
      }

      console.log(response, 'submit battery status response');
    } catch (error) {
      console.error('Error Accepting', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to accept. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const handleSubmitBattery = async () => {
    try {
      const payload = {
        battery_numbers: batteryData
          .map((item) => item.entered_battery_no?.trim())
          .filter((val) => val),

        oldreplaceBatteryNo: batteryData
          .map((item) => item.battery_no?.trim())
          .filter((val) => val),

        postock_id: drawerData?.postock_id,
        vinNo: drawerData?.vin_no,
        item_id: drawerData?.item_id,
      };

      const response = await axiosInstance.patch(
        `/jobcard/dispatchAdmin/${drawerData?.job_card_id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.status === 200) {
        toggleDrawer();

        Swal.fire({
          title: 'Success',
          text: 'Item submitted successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        fetchJobCardListRefresh();
      }

      console.log(response, 'submit item status response');
    } catch (error) {
      console.error('Error submitting item status:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to submit battery. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const handleApprovalAPIApprove = async () => {
    try {
      const payload = {
        //   approvestatus: "Accept",
        isAccepted: 1,
        postock_id: drawerData?.postock_id,
        vin_no: drawerData?.vin_no,
      };

      const response = await axiosInstance.patch(
        `/jobcard/ApprovalAdmin/${drawerData?.job_card_id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.status === 200) {
        //   fetchOrderDetails();
        //   fetchBatteryDetails();
        fetchJobCardList();
        setTableSection(true);

        Swal.fire({
          title: 'Success',
          text: 'Order approved successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error('API Error:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to approve order. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const handleRejectAPIApprove = async () => {
    try {
      const payload = {
        //   approvestatus: "Accept",
        isAccepted: 0,
        postock_id: drawerData?.postock_id,
        vin_no: drawerData?.vin_no,
      };

      const response = await axiosInstance.patch(
        `/jobcard/ApprovalAdmin/${drawerData?.job_card_id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.status === 200) {
        //   fetchOrderDetails();
        //   fetchBatteryDetails();

        Swal.fire({
          title: 'Success',
          text: 'Order Rejected successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        setTableSection(true);
        fetchJobCardList();
        fetchJobCardListRefresh();
      }
    } catch (error) {
      console.error('API Error:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to approve order. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const isFinalStage = drawerData?.stage_status >= 7;

  const hideSubmit =
    (userType === 'businesspartner' && drawerData?.stage_status === 7) ||
    (userType === 'businesspartner' && drawerData?.stage_status === 8) ||
    (userType === 'dealeruser' && drawerData?.stage_status === 9) ||
    (userType === 'dealeruser' && drawerData?.stage_status === 4);

  const DealerInputs = [
    ...(userType === 'dealeruser' &&
    (drawerData?.stage_status === 2 || drawerData?.stage_status === 1)
      ? [
          {
            name: 'transportation_mode',
            label: 'Mode of transportation',
            placeholder: 'Enter mode of transportation',
            type: 'text',
            required: true,
            gridClass: 'col-lg-4',
            validation: {
              required: true,
            },
          },
          {
            name: 'dispatch_remark',
            label: 'Remark',
            placeholder: 'Enter Remark',
            type: 'text',
            required: true,
            gridClass: 'col-lg-4',
            validation: {
              required: true,
            },
          },
          {
            name: 'dispatch_date',
            label: 'Dispatch Date',
            type: 'date',
            required: true,
            validation: {
              required: true,
            },
            minDate: new Date(),
            // placeholder: "Days",
            // disabled: true,
            gridClass: 'col-lg-4',
          },
        ]
      : []),
    ...(userType === 'businesspartner'
      ? [
          {
            name: 'upload_invoice',
            label: 'Upload Invoice',
            type: 'file',
            allowedExtensions: ['jpg', 'jpeg', 'png', 'pdf'],
            required: true,
            validation: {
              required: true,
            },
            gridClass: 'col-lg-4',
          },
        ]
      : []),
  ];

  const handleFormSubmitAdmin = async (formData) => {
    console.log('dealerformdata', formData);

    const errors = {};
    let isValid = true;

    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to upload this invoice note?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // setLoading(true);
          const payload = new FormData();

          if (formData.upload_invoice) {
            payload.append('upload_invoice', formData.upload_invoice);
          }
          payload.append('type_of_service', drawerData.type_of_service || '');
          payload.append(
            'service_type',
            drawerData.repair_or_replacement_status || '',
          );
          payload.append('dealer_id', drawerData.dealer_id || '');
          payload.append('item_id', drawerData.item_id || '');

          // API call to create a dealer
          const response = await axiosInstance.patch(
            `/admin/deliveryNote/${drawerData?.job_card_id}`,
            payload,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            setIsInvoiceUploaded(true);

            Swal.fire({
              title: 'Success',
              text: 'Invoice uploaded successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              // navigate(ROUTES_NAVIGATION.DEALERLIST);
            });
          }
        } catch (error) {
          console.error('Error adding dealer:', error);

          const status = error.response?.status;
          let errorMessage =
            error.response?.data?.message ||
            'An error occurred while processing your request.';

          // If backend indicates record exists, show friendly message
          if (
            status === 403 ||
            (typeof errorMessage === 'string' &&
              /already exists/i.test(errorMessage))
          ) {
            errorMessage =
              'A dealer with this email ID or contact number already exists.';
          }

          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } finally {
          // setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'The dispatch record was not created.',
          icon: 'info',
          confirmButtonText: 'OK',
        });
        // setLoading(false);
      }
    });
  };

  const handleFormSubmitDealer = async (formData) => {
    console.log('dealerformdata', formData);

    const errors = {};
    let isValid = true;

    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to add the delivery note?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // setLoading(true);
          // const payload = new FormData();

          // payload.append("transportation_mode", formData.transportation_mode || "");
          // payload.append("dispatch_remark", formData.dispatch_remark);
          // // payload.append("dealer_desc", formData.dealer_desc);
          // payload.append("dispatch_date", formData.dispatch_date);
          // payload.append("sales_person_id", formData.sales_person_name);

          const payload = {
            transportation_mode: formData.transportation_mode,
            dispatch_remark: formData.dispatch_remark,
            dispatch_date: formData.dispatch_date,
            type_of_service: drawerData?.type_of_service,
          };

          // API call to create a dealer
          const response = await axiosInstance.patch(
            `/deliveryNote/${drawerData?.job_card_id}`,
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'Invoice uploaded successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              // navigate(ROUTES_NAVIGATION.DEALERLIST);
              downloadDeliveryNote();
            });
          }
        } catch (error) {
          console.error('Error adding dealer:', error);

          const status = error.response?.status;
          let errorMessage =
            error.response?.data?.message ||
            'An error occurred while processing your request.';

          // If backend indicates record exists, show friendly message
          if (
            status === 403 ||
            (typeof errorMessage === 'string' &&
              /already exists/i.test(errorMessage))
          ) {
            errorMessage =
              'A dealer with this email ID or contact number already exists.';
          }

          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } finally {
          // setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'The record is not created',
          icon: 'info',
          confirmButtonText: 'OK',
        });
        // setLoading(false);
      }
    });
  };

  return (
    <div>
      <div>
        <p>
          <strong>Product Name:</strong> {drawerData?.item_name}
        </p>
        <p>
          <strong>Complaint:</strong> {drawerData?.complain_name}
        </p>
        <p>
          <strong>Item Type:</strong> {drawerData?.repair_or_replacement_text}
        </p>
        {/* <p>
          <strong>Customer Purchase Date</strong> {drawerData?.batteryWarrntyFrom}
        </p> */}
        {/* <p>
          <strong>Customer Purchase Date</strong> {drawerData?.batteryWarrntyFrom}
        </p> */}
        {/* <p>
          <strong>Replacement Parts:</strong> {drawerData?.replacement_parts}
        </p>
        <p>
          <strong>Repair Details:</strong> {drawerData?.repair_details}
        </p> */}
        {/* <p>
          <strong>Status:</strong> {drawerData?.status}
        </p> */}

        {/* {userType === "businesspartner" && (


         ) */}

        {userType === 'businesspartner' && drawerData?.stage_status === 4 ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              gap: '15px',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <button className="submit-btn" onClick={handleApprovalAPIApprove}>
                Approve
              </button>
            </div>

            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <button className="submit-btn" onClick={handleRejectAPIApprove}>
                Reject
              </button>
              {/* )} */}
            </div>
          </div>
        ) : null}
      </div>

      {/* {showTableSection &&  (
      <>
        <div className="mt-4">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Serial No.</th>
                
                <th>Replaced Items</th>
              </tr>
            </thead>

            <tbody>
              {batteryData?.length > 0 ? (
                batteryData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row?.battery_no || "--"}</td>

                   
                    {userType === "businesspartner" &&
                      drawerData?.repair_or_replacement_text !== "REPAIR" && (
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Serial No."
                            value={row?.entered_battery_no || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              setBatteryData((prev) =>
                                prev.map((item, i) =>
                                  i === idx
                                    ? { ...item, entered_battery_no: value }
                                    : item
                                )
                              );
                            }}
                          />
                        </td>
                      )}

                    {(userType !== "businesspartner" ||
                      drawerData?.repair_or_replacement_text === "REPAIR") && (
                      <td>{row?.replaced_battery || "--"}</td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={
                      userType === "businesspartner"
                        ? drawerData?.repair_or_replacement_text === "REPAIR"
                          ? 2
                          : 2
                        : 2
                    }
                    className="text-center"
                  >
                    No battery details available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div
          style={{ display: "flex", justifyContent: "end" }}
          className="mt-3"
        >
          <button
            className="btn btn-primary submit-btn"
            style={{ backgroundColor: "#7BD755", border: "#7BD755" }}
           

            onClick={
              userType === "businesspartner"
                ? handleSubmitBattery
                : userType === "dealeruser" &&
                  (drawerData?.stage_status === 7 ||
                    drawerData?.stage_status === 8)
                ? handleAcceptBattery
                : handleSubmit
            }
          >
            Submit
          </button>
        </div>
      </>
     )} */}
      {(userType === 'dealeruser' ||
        isFinalStage ||
        (userType === 'businesspartner' && showTableSection) ||
        (userType !== 'dealeruser' &&
          userType !== 'businesspartner' &&
          showTableSection)) && (
        <>
          <div className="mt-4">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Serial No.</th>
                  <th>Replaced Items</th>
                </tr>
              </thead>

              {/* <tbody>
                {batteryData?.length > 0 ? (
                  batteryData.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row?.battery_no || "--"}</td>

                      {userType === "businesspartner" &&
                        drawerData?.repair_or_replacement_text !== "REPAIR" && (
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Serial No."
                              value={row?.entered_battery_no || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setBatteryData((prev) =>
                                  prev.map((item, i) =>
                                    i === idx
                                      ? { ...item, entered_battery_no: value }
                                      : item
                                  )
                                );
                              }}
                            />
                          </td>
                        )}

                      {(userType !== "businesspartner" ||
                        drawerData?.repair_or_replacement_text ===
                          "REPAIR") && <td>{row?.replaced_battery || "--"}</td>}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center">
                      No battery details available
                    </td>
                  </tr>
                )}
              </tbody> */}
              <tbody>
                {batteryData?.length > 0 ? (
                  batteryData.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row?.battery_no || '--'}</td>

                      {/* INPUT → only before final stage */}
                      {userType === 'businesspartner' &&
                        drawerData?.repair_or_replacement_text !== 'REPAIR' &&
                        !isFinalStage && (
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Serial No."
                              value={row?.entered_battery_no || ''}
                              onChange={(e) => {
                                const value = e.target.value;
                                setBatteryData((prev) =>
                                  prev.map((item, i) =>
                                    i === idx
                                      ? { ...item, entered_battery_no: value }
                                      : item,
                                  ),
                                );
                              }}
                            />
                          </td>
                        )}

                      {/* TEXT → final stage OR non-businesspartner OR REPAIR */}
                      {(isFinalStage ||
                        userType !== 'businesspartner' ||
                        drawerData?.repair_or_replacement_text ===
                          'REPAIR') && (
                        <td>
                          {row?.replaced_battery ||
                            row?.entered_battery_no ||
                            '--'}
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center">
                      No battery details available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* <div
            style={{ display: "flex", justifyContent: "end" }}
            className="mt-3"
          >
            <button
              className="btn btn-primary submit-btn"
              style={{ backgroundColor: "#7BD755", border: "#7BD755" }}
              onClick={
                userType === "businesspartner"
                  ? handleSubmitBattery
                  : userType === "dealeruser" &&
                    (drawerData?.stage_status === 7 ||
                      drawerData?.stage_status === 8)
                  ? handleAcceptBattery
                  : handleSubmit
              }
            >
              Submit
            </button>
          </div> */}

          {/* {(userType === "businesspartner" || userType === "dealeruser") && (drawerData?.stage_status === 2 || drawerData?.stage_status === 4) ? (
          <div style={{ margin: "0px" }} className="form-container">
            <DynamicForm
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmitDealer}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
            <div className="btncontainer mt-3">
              {userType === "dealeruser" ? (
                <button
                  onClick={() => {
                    handleFormSubmitDealer(formData);
                  }}
                  className="submit-btn"
                >
                  Submit
                </button>
              ) : (
                <button
                  onClick={() => {
                    handleFormSubmitAdmin(formData);
                  }}
                  className="submit-btn"
                >
                  Submit
              
                </button>
              )}
            </div>
          </div>
           ) : null}  */}

          {(userType === 'dealeruser' &&
            (drawerData?.stage_status === 2 ||
              drawerData?.stage_status === 1)) ||
          (userType === 'businesspartner' &&
            (drawerData?.stage_status === 4 ||
              drawerData?.stage_status === 5)) ? (
            <div style={{ margin: '0px' }} className="form-container">
              <DynamicForm
                formConfig={DealerInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmitAdmin}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              <div className="btncontainer mt-3">
                {userType === 'dealeruser' ? (
                  <button
                    className="submit-btn"
                    disabled={
                      !isFormValid(DealerInputs, formData, validationErrors) ||
                      false
                    }
                    style={buttonStyle(
                      DealerInputs,
                      formData,
                      validationErrors,
                      false,
                    )}
                    onClick={() => {
                      handleFormSubmitDealer(formData);
                    }}
                  >
                    Submit
                  </button>
                ) : (
                  <button
                    className="submit-btn"
                    disabled={
                      !isFormValid(DealerInputs, formData, validationErrors) ||
                      false
                    }
                    style={buttonStyle(
                      DealerInputs,
                      formData,
                      validationErrors,
                      false,
                    )}
                    onClick={() => {
                      handleFormSubmitAdmin(formData);
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          ) : null}

          {!hideSubmit && (
            <div
              style={{ display: 'flex', justifyContent: 'end' }}
              className="mt-3"
            >
              <button
                className="btn btn-primary submit-btn"
                disabled={
                  !isFormValid(DealerInputs, formData, validationErrors) ||
                  false
                }
                style={buttonStyle(
                  DealerInputs,
                  formData,
                  validationErrors,
                  false,
                )}
                // style={{ backgroundColor: '#7BD755', border: '#7BD755' }}
                // onClick={
                //   userType === "businesspartner"
                //     ? handleSubmitBattery
                //     : userType === "dealeruser" &&
                //         (drawerData?.stage_status === 7 ||
                //           drawerData?.stage_status === 8)
                //       ? handleAcceptBattery
                //       : handleSubmit
                // }

                onClick={() => {
                  if (userType === 'businesspartner') {
                    // 🚨 Apply validation ONLY for handleSubmitBattery
                    if (!isInvoiceUploaded) {
                      Swal.fire({
                        title: 'Warning',
                        text: 'Please upload the invoice note before proceeding with dispatch.',
                        icon: 'warning',
                        confirmButtonText: 'OK',
                      });
                      return;
                    }

                    handleSubmitBattery();
                  } else if (
                    userType === 'dealeruser' &&
                    (drawerData?.stage_status === 7 ||
                      drawerData?.stage_status === 8)
                  ) {
                    handleAcceptBattery();
                  } else {
                    handleSubmit();
                  }
                }}
              >
                {userType === 'dealeruser' && drawerData?.stage_status === 7
                  ? 'Submit'
                  : userType === 'dealeruser'
                    ? 'Dispatch from dealer'
                    : 'Dispatch from admin'}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ReplacementAndRepairDetails;
